import React from 'react'
import * as Sentry from '@sentry/react'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true }
  }

  componentDidCatch(error, info) {
    Sentry.captureException(error)
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null })
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-b from-gray-50 to-white p-6">
          <div className="w-full xl:w-1/2 bg-white border border-gray-100 rounded-2xl shadow-lg p-8 text-center">
            <div className="mx-auto w-24 h-24 rounded-full bg-red-50 flex items-center justify-center mb-6">
              {/* simple inline SVG icon */}
              <svg
                className="w-12 h-12 text-red-600 animate-pulse"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.5"
                  d="M12 8v4m0 4h.01M21 12c0 4.97-4.03 9-9 9s-9-4.03-9-9 4.03-9 9-9 9 4.03 9 9z"
                />
              </svg>
            </div>

            <h2 className="text-4xl font-semibold text-gray-900 mb-6">
              Something went wrong
            </h2>
            <p className="text-lg text-gray-500 mb-6">
              An unexpected error occurred. We've logged the issue — try
              refreshing, or report it if it keeps happening.
            </p>

            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <button
                onClick={this.handleRetry}
                className="inline-flex items-center justify-center px-5 py-2 rounded-lg shadow-sm border border-transparent text-lg font-medium focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 bg-indigo-600 text-white hover:bg-indigo-700"
              >
                Try again
              </button>

              <button
                onClick={() => window.location.reload()}
                className="inline-flex items-center justify-center px-5 py-2 rounded-lg bg-white text-lg font-medium border border-gray-200 text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              >
                Reload page
              </button>
            </div>

            <details className="mt-6 text-left text-xl text-gray-400 bg-gray-50 p-3 rounded-md">
              <summary className="cursor-pointer">Error details</summary>
              <pre className="mt-2 whitespace-pre-wrap text-[11px] text-gray-600">
                {String(this.state.error)}
              </pre>
            </details>
          </div>
        </div>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
